import styles from './index.css';

// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import classNames from 'classnames';

import {Option} from '../../Definitions';
import Icon from '../Icon';
import {useHandlerOnOuterClick} from '../../Utils/Hooks';

type SelectboxProps = {
	options: Option[];
	onSelect: (value: string|number) => void;
	value?: string|number;
	required?: boolean;
	hasEmptyOption?: boolean;
	displayTiny?: boolean;
	className?: string;
}
export default (props: SelectboxProps) => {
	const {onSelect, value = '', options = [], hasEmptyOption = false, displayTiny, className} = props;

	if (!options.length) {
		console.warn('Missing "options" for ControlledSelectbox.');
		return null;
	}

	// Toggle-state.
	const [isOpen, setIsOpen] = React.useState(false);
	const toggle = () => setIsOpen(!isOpen);
	const close = () => setIsOpen(false);
	const {node, enableHandler, disableHandler} = useHandlerOnOuterClick(close, false);

	React.useEffect(() => {
		if (isOpen) {
			enableHandler();
		} else {
			disableHandler();
		}
	}, [isOpen]);

	const select = (value: string|number) => () => {
		onSelect(value);
		close();
	};

	const {label: selectedLabel, value: selectedValue = ''} = options.find(option => option.value === value) || {};

	return (
		<div
			ref={node}
			className={classNames(
				styles.selectbox,
				isOpen && styles.isOpen,
				displayTiny && styles.displayTiny,
				className
			)}
		>
			<div
				onClick={toggle}
				className={styles.toggler}
			>
				<span className={styles.value}>
					{selectedLabel || selectedValue}
				</span>
				<Icon name="chevron-down" isFlipped={isOpen} className={styles.icon}/>
			</div>
			<div className={styles.options}>
				{
					hasEmptyOption && (
						<div
							key=""
							className={styles.option}
							onClick={select('')}
						></div>
					)
				}
				{
					options.map(({value, label}) => (
						<div
							key={value}
							className={styles.option}
							onClick={select(value)}
						>
							{label || value}
						</div>
					))
				}
			</div>
		</div>
	);
}
